import Modal from "~/shared/ui/Fields/Modal";
import s from "~/components/Forms/DealerPassportForm/ui/ManageEmailDomains/ManageEmailDomains.less";
import Button from "~/shared/ui/Fields/Button";
import React, { useEffect } from "react";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { useTranslation } from "react-i18next";
import { useManagementDomains } from "../helper";

export const DeleteModal = ({ refetch }) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();

  const { status, name, currentId } = useGetLocationData();
  const { deleteDomain } = useManagementDomains();

  const handleCloseDeleteModal = () => {
    setData("status", null);
  };

  const handleDelete = () => {
    deleteDomain({ variables: { domainId: currentId } }).then(() => {
      refetch();
      handleCloseDeleteModal();
    });
  };

  return (
    <Modal
      isOpen={status === "delete"}
      title={`Вы хотите удалить домен ${name} ?`}
      actionClose={handleCloseDeleteModal}
    >
      <div className={s.buttons}>
        <Button small txtBtn={t("ui.delete")} onClick={handleDelete} />
        <Button small txtBtn={t("ui.close")} onClick={handleCloseDeleteModal} />
      </div>
    </Modal>
  );
};
